import React from 'react';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { DocumentUtils } from '../../shared/utils/DocumentUtils';
import { BreadcrumbsManagerInstance } from '../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../shared/breadcrumbs/Breadcrumbs';
import { DocumentDetailContent } from '../../documents/components/DocumentDetailContent';
import RouterUtils from '../../shared/routing/RouterUtils';
import { PsRoutes } from '../../shared/routing/Routes';
import { PsContractor } from './shared/PsContractor';
import { PsMachine } from './shared/PsMachine';

export class MachineDocumentDetailScreen extends React.Component {

    constructor(init) {
        super(init);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_CONTRACTORS,
            Breadcrumbs.MY_CONTRACTORS_DETAIL,
            Breadcrumbs.MACHINES_EMPTY,
            Breadcrumbs.MY_CONTRACTORS_MACHINES_DETAIL,
            Breadcrumbs.DOCUMENTS_EMPTY,
            Breadcrumbs.MY_CONTRACTORS_OUTSOURCE_DOCUMENT_DETAIL,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;
        const { location, match } = this.props;
        const { documentId } = match.params;
        const title = I18nUtils.tr('TR_DOCUMENTO_DE_MI_MAQUINA_PARA_MI_CONTRATISTA');

        return (
            <PsPage
                title={title}
                location={location}
                breadcrumbs={breadcrumbs}
            >
                <DocumentDetailContent
                    documentId={documentId}
                    appendBreadcrumb={this.appendBreadcrumb}
                />
            </PsPage>
        );
    }

    appendBreadcrumb = (document) => {
        if (!document) {
            return;
        }

        const { location, match } = this.props;
        const { machineId } = match.params;
        const contractor = PsContractor.fromAPICompany(document.contractor);
        const machine = PsMachine.fromAPIMachine(document.machine);

        BreadcrumbsManagerInstance.finishLoading({
            id: Breadcrumbs.MY_CONTRACTORS_DETAIL.id,
            url: '',
            description: contractor.name(),
        });

        BreadcrumbsManagerInstance.finishLoading({
            id: Breadcrumbs.MY_CONTRACTORS_MACHINES_DETAIL.id,
            url: RouterUtils.generateRoute(PsRoutes.MY_CONTRACTORS_MACHINES_DETAIL, { id: machineId }),
            description: machine.shortDescription(),
        });

        BreadcrumbsManagerInstance.finishLoading({
            id: Breadcrumbs.MY_CONTRACTORS_OUTSOURCE_DOCUMENT_DETAIL.id,
            url: location.pathname,
            description: DocumentUtils.getDocumentName(document),
        });

        this.setState({
            breadcrumbs: [...BreadcrumbsManagerInstance.breadcrumbs()],
        });
    };
}

MachineDocumentDetailScreen.propTypes = {};

MachineDocumentDetailScreen.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-contractors/document/MachineDocumentDetailScreen.jsx